import { boolean, integer, pgTable, text, timestamp, unique, index, foreignKey, varchar, primaryKey } from 'drizzle-orm/pg-core';
import { sql } from 'drizzle-orm';
import { tag } from './tags';

export const country = pgTable('Country', {
  id: integer().primaryKey().generatedAlwaysAsIdentity(),
  // ISO 3166-1 alpha-2, UPPERCASE. Используется для emoji-флага на клиенте.
  code: varchar({ length: 2 }).notNull(),
  // Локализованное имя по умолчанию (русское). Альтернативные локали — отдельным шагом.
  name: text().notNull(),
  // Опционально — телефонный префикс ("+998", "+7"), для будущих форм.
  dialCode: varchar({ length: 8 }),
  isActive: boolean().notNull().default(true),
  sortOrder: integer().notNull().default(0),
  // Список ISO-4217 кодов валют, разрешённых для пользователей этой страны
  // (например ['UZS','USD']). Пустой массив = ограничения нет, доступны все.
  // Используется на платформе для фильтрации currencyPreference в селекторе.
  allowedCurrencies: text().array().notNull().default(sql`'{}'::text[]`),
  createdAt: timestamp({ precision: 3, mode: 'date' }).default(sql`CURRENT_TIMESTAMP`).notNull(),
  updatedAt: timestamp({ precision: 3, mode: 'date' }).notNull().$onUpdate(() => new Date()),
}, (table) => [
  unique('Country_code_unique').on(table.code),
  index('Country_isActive_idx').on(table.isActive),
  index('Country_sortOrder_idx').on(table.sortOrder),
]);

// Связь N:M между Country и Tag. Когда пользователь выбирает страну,
// все её теги автоматически проставляются ему через UserTag (source='country_auto').
export const countryTag = pgTable('CountryTag', {
  countryId: integer().notNull(),
  tagId: integer().notNull(),
  createdAt: timestamp({ precision: 3, mode: 'date' }).default(sql`CURRENT_TIMESTAMP`).notNull(),
}, (table) => [
  primaryKey({ columns: [table.countryId, table.tagId] }),
  index('CountryTag_tagId_idx').on(table.tagId),
  foreignKey({ columns: [table.countryId], foreignColumns: [country.id] }).onDelete('cascade'),
  foreignKey({ columns: [table.tagId], foreignColumns: [tag.id] }).onDelete('cascade'),
]);
